import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { PATH_APP } from "../paths";
import { AccountWrapper } from "./style";
import AccountProfile from "@/views/Account/Profile";
import AccountSecurity from "@/views/Account/Security";
import Sidebar from "@/views/Layout/Sidebar";
import { MENU_ITEMS } from "@/views/Layout/Sidebar/type";
import { useTranslation } from "react-i18next";

export default function AccountRouter() {
	const { i18n } = useTranslation();
	const [menuItems, setMenuItems] = useState(
		MENU_ITEMS[i18n.language === "ko" ? 0 : 1],
	);
	useEffect(() => {
		switch (i18n.language) {
			case "ko":
				setMenuItems(MENU_ITEMS[0]);
				break;
			default:
				setMenuItems(MENU_ITEMS[1]);
		}
	}, [i18n.language]);
	return (
		<AccountWrapper>
			<Sidebar title="Account" menuItem={menuItems.account} />
			<Switch>
				<Route
					exact={true}
					path={PATH_APP.account.profile}
					component={AccountProfile}
				/>
				<Route
					exact={true}
					path={PATH_APP.account.security}
					component={AccountSecurity}
				/>
			</Switch>
		</AccountWrapper>
	);
}
